// @ts-expect-error TS(7016)
import makeSubject from "callbag-subject";
import { Middleware } from "redux";

export const actions$ = makeSubject();

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const actionStreamMiddleware: Middleware = () => (next: any) => (action: any) => {
  actions$(1, action);
  return next(action);
};
